export const ATTACHMENTS = "attachments";
export const FILE = "file";
export const DESCRIPTION = "description";
export const SHOW_TO_CUSTOMER = "showToCustomer";

export const tabs = [
  {title: 'PM Attachments', value: "pm"},
  // {title: 'QC Attachments', value: "qc"},
  // {title: 'SC Attachments', value: "sc"},
]

export const fakeTabs = [
  {title: '', value: "sm"}
]

export const approvedTabs = [
  {title: 'SM Attachments', value: "sm"}
]